import { render } from "./OrderItem.vue?vue&type=template&id=7e0ea81d&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=7e0ea81d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0ea81d"]])

export default __exports__